<template>
  <el-dialog title='详情' :visible.sync='detailDialogVisible' width='900px' center>
    <div class='detail' v-loading='detailLoading'>
      <el-tabs v-model=' activeName '>
        <el-tab-pane label='基础信息' name='first'>
      <div class='baseInfo'>
        <div class='baseInfoContent'>
          <el-form :model='detailData' label-position='left'>
            <el-row :gutter='10'>
              <el-col :span='12'>
                <el-form-item label='油价编号:'>
                  <span>{{ detailData.number }}</span>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='对账单标题:'>
                  <span>{{ detailData.reconciliationTitle }}</span>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='标题:'>
                  <span>{{ detailData.title }}</span>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='公司类型:'>
                  <span>{{ detailData.companyType|getCompanyType }}</span>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='公司名称:'>
                  <span>{{ detailData.companyName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span='12'>
                <el-form-item label='合计油价:'>
                  <span>{{ detailData.oilPrice }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class='operation'>
          <div class='operationTitle'>
            <div class='line' />
            <span>操作记录</span>
          </div>
          <div class='baseInfoTable mt10'>
            <el-table :data='detailData.operateRecordList' border max-height='300'>
              <el-table-column prop='createTime' label='操作时间' align='center' width='160px' />
              <el-table-column prop='operateType' label='操作类型' align='center' />
              <el-table-column prop='operationName' label='操作人' align='center' />
              <el-table-column prop='remark' label='备注' align='center' />
            </el-table>
          </div>
        </div>
      </div>
        </el-tab-pane>
        <el-tab-pane label='结算费用' name='second'>
          <div class='baseInfo'>
            <div class='operationTable' style='margin-top:0;'>
              <el-table v-if=' searchForm.companyType === 1' :data='detailTable' border script>
                <el-table-column prop='batchNumber' label='批次号' min-width='100' align='center' show-overflow-tooltip />
                <el-table-column prop='waybillNo' label='运单号' min-width='120' align='center' show-overflow-tooltip />
                <el-table-column prop='frameNumber' label='车架号' min-width='150' align='center' show-overflow-tooltip />
                <el-table-column prop='brandName' label='品牌' align='center' show-overflow-tooltip />
                <el-table-column prop='modelName' label='型号' align='center' show-overflow-tooltip />
                <el-table-column prop='startName' label='起始地' min-width='150' align='center' show-overflow-tooltip/>
                <el-table-column prop='deliveryName' label='交车地' min-width='150' align='center' show-overflow-tooltip/>
                <el-table-column prop='startPortName' label='起始港' min-width='150' align='center' show-overflow-tooltip />
                <el-table-column prop='deliveryPortName' label='目的港' min-width='150' align='center' show-overflow-tooltip />
                <el-table-column prop='taxRate' label='税率' align='center' />
                <el-table-column prop='standingBookMonth' label='台账月' min-width='100' align='center' show-overflow-tooltip />
                <el-table-column prop='taxContractPrice' label='含税合同价' align='center' show-overflow-tooltip />
                <el-table-column prop='taxPreparePrice' label='含税预结算价' align='center' show-overflow-tooltip />
                <el-table-column prop='contractPrice' label='不含税合同价' align='center' show-overflow-tooltip />
                <el-table-column prop='preparePrice' label='不含税预结算价' align='center' show-overflow-tooltip />
                <el-table-column prop='taxAdjustPrice' label='含税调整金额' align='center' show-overflow-tooltip />
                <el-table-column prop='oilPrice' label='油价联动金额' align='center' show-overflow-tooltip />
              </el-table>
              <el-table v-else :data='detailTable' border script>
                <el-table-column prop='consignorName' label='委托商' min-width='100' align='center' show-overflow-tooltip />
                <el-table-column prop='batchNumber' label='批次号' min-width='100' align='center' show-overflow-tooltip />
                <el-table-column prop='waybillNo' label='运单号' min-width='120' align='center' show-overflow-tooltip />
                <el-table-column prop='frameNumber' label='车架号' min-width='120' align='center' show-overflow-tooltip />
                <el-table-column prop='brandName' label='品牌' align='center' show-overflow-tooltip />
                <el-table-column prop='modelName' label='型号' align='center' show-overflow-tooltip />
                <el-table-column prop='departurePlace' label='起始地' min-width='150' align='center' show-overflow-tooltip/>
                <el-table-column prop='arrivePlace' label='交车地' min-width='150' align='center' show-overflow-tooltip/>
                <el-table-column prop='departurePort' label='起始港' min-width='150' align='center' show-overflow-tooltip />
                <el-table-column prop='arrivePort' label='目的港' min-width='150' align='center' show-overflow-tooltip />
                <el-table-column prop='standingBookMonth' label='台账月' min-width='100' align='center' show-overflow-tooltip />
                <el-table-column prop='taxContractPrice' label='含税合同价' align='center' show-overflow-tooltip />
                <el-table-column prop='taxPreparePrice' label='含税预结算价' align='center' show-overflow-tooltip />
                <el-table-column prop='contractPrice' label='不含税合同价' align='center' show-overflow-tooltip />
                <el-table-column prop='preparePrice' label='不含税预结算价' align='center' show-overflow-tooltip />
                <el-table-column prop='taxAdjustPrice' label='含税调整金额' align='center' show-overflow-tooltip />
              </el-table>
            </div>
            <div class='paginationContainer' style='display: flex;align-items: center;padding: 10px 20px;'>
              <span>共{{ detailTotal }}条</span>
              <el-pagination background :page-sizes=' [10, 20, 30, 40] ' layout='sizes,prev, pager, next,jumper'
                             :total=' detailTotal ':current-page.sync='searchForm.page'
                             :page-size='searchForm.rows'
                             @prev-click=' detailCurrentChange ' @next-click=' detailCurrentChange ' />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>
<script>
import {getDetail, getPageList} from "@/service/contract";
import {getPageId} from "@/service/DevOps";

export default {
  data(){
    return{
      activeName: 'first',
      detailDialogVisible: false,
      detailLoading: false,
      detailData: {
        title: '',
        number: '',
        companyName: '',
        companyType: '',
        reconciliationTitle: '',
        oilPrice: '',
        detailTable: []
      },
      searchForm: {
        type: 1,
        settNo: '',
        title: '',
        companyName: '',
        startTime: '',
        endTime: '',
        settType: '',
        companyType: '',
        status: '',
        page: 1,
        rows: 10,
      },
      settlement: 1, // 结算方式 1：合同价 2：预结算价
      detailTable: [],
      detailTotal: 0,
    }
  },
  filters:{
    getCompanyType(val) {
      switch (val) {
        case 0:
          return '委托商';
        case 1:
          return '供应商';
      }
    },
  },

  methods: {
    dialogOpen(id,companyType) {
      this.detailDialogVisible = true;
      this.searchForm.companyType = companyType
      this.getPageId(id)
      this.getPageList(id)
    },
    async getPageId(id) {
      const {
        status,
        message,
        data,
      } = await getDetail({
        id,
      });
      if (status !== 0) return this.$message.warning(message);
      this.detailData = data;
    },
    async getPageList(id) {
      const {
        status,
        message,
        data,
      } = await getPageList({
        id,
        type: this.searchForm.companyType,
        page: this.searchForm.page,
        rows: this.searchForm.rows
      });
      if (status !== 0) return this.$message.warning(message);
      this.detailTable = data.records;
      this.detailTotal = data.total;
    },
    // 结算费用页数
    detailCurrentChange(page) {
      this.searchForm.page = page;
      this.getPageListSCFI();
    },
  }
}
</script>

<style scoped lang="scss">

</style>
